import { Breadcrumbs as MBreadcrumbs, Flex } from '@mantine/core';
import { useBreadcrumbs } from '@shared/lib';

export const Breadcrumbs = () => {
  const context = useBreadcrumbs();
  const breadcrumb = context?.breadcrumb;

  if (!breadcrumb) {
    return null;
  }

  return (
    <Flex
      py={16}
      display={{ base: 'none', md: 'flex' }}
      w='100%'
      miw={0}
      style={{ overflow: 'hidden' }}
    >
      <MBreadcrumbs
        styles={{
          root: {
            flexWrap: 'nowrap',
            minWidth: 0,
            overflow: 'hidden',
            width: '100%',
          },
          breadcrumb: {
            minWidth: 0,
            overflow: 'hidden',
          },
        }}
      >
        {breadcrumb}
      </MBreadcrumbs>
    </Flex>
  );
};
